import "./App.css";
import { Route, Routes } from "react-router-dom";
import {
  NavBar,
  Home,
  WorkWithUs,
  Contact,
  Footer,
  Faq,
  OurTutors,
} from "./components";
import Policies from "./components/pages/compliance/Policies";
import LowerLevelTutoring from "./components/pages/newServices/LowerLevelTutoring";
import VceTutoring from "./components/pages/newServices/VceTutoring";
import VceEssayExamMarking from "./components/pages/newServices/VceEssayExamMarking";
import VceStudyGuides from "./components/pages/newServices/VceStudyGuides";
import { ArrowSmallUpIcon } from "@heroicons/react/20/solid";
import { animateScroll } from "react-scroll";

const App = () => {
  return (
    <div className="App">
      <NavBar />
      <main>
        <Routes>
          {/* Home */}
          <Route exact="true" path="/" element={<Home />} />

          {/* About */}
          <Route exact="true" path="/our-tutors" element={<OurTutors />} />
          <Route exact="true" path="/faq" element={<Faq />} />

          {/* Services */}
          <Route
            exact="true"
            path="/english-math-tutoring"
            element={<LowerLevelTutoring />}
          />
          <Route
            exact="true"
            path="/vce-hsc-qce-tutoring"
            element={<VceTutoring />}
          />
          <Route
            exact="true"
            path="/vce-hsc-qce-essay-exam-marking"
            element={<VceEssayExamMarking />}
          />
          <Route
            exact="true"
            path="/vce-hsc-qce-study-guides"
            element={<VceStudyGuides />}
          />

          {/* Contact */}
          <Route exact="true" path="/work-with-us" element={<WorkWithUs />} />
          <Route exact="true" path="/contact" element={<Contact />} />

          {/* Legal */}
          <Route exact="true" path="/policies" element={<Policies />} />
        </Routes>
        <button
          className="sticky bottom-[10%] left-[80%] lg:left-[90%] z-[50] bg-transparent w-10 h-10"
          onClick={() => {
            animateScroll.scrollToTop();
          }}>
          <ArrowSmallUpIcon className="bg-blue rounded-full text-white ring ring-blue ring-offset-2 m-[0.35rem]" />
        </button>
      </main>
      <Footer />
    </div>
  );
};

export default App;
